<button (click)="hiddenNav = !hiddenNav" *ngIf="hiddenNav" class="btn btn-sm btn-nav-hidden">
    <mat-icon color="">arrow_forward_ios</mat-icon>
</button>
<div
    class="main-nav d-flex flex-column justify-content-between p-4 py-5"
    [ngClass]="{ 'hidden-nav': hiddenNav }"
>
    <div class="mb-100">
        <span class="logo d-flex align-items-center m-auto justify-content-center">
            <img
                src="./assets/images/tmc-white-logo.png"
                alt="Media Connector"
                title="Media Connector"
            />
        </span>
        <nav class="mt-5">
            <ul class="m-0 py-4 px-0">
                <li>
                    <a
                        [routerLink]="['/my-campaigns']"
                        routerLinkActive="selected"
                        class="text-center p-3 d-inline-block text-white"
                        ngbTooltip="My Campaigns"
                        placement="right"
                    >
                        <img
                            src="./assets/images/icons/nav/screen.svg"
                            alt="My Campaigns"
                            title="My Campaigns" />
                        <img
                            src="./assets/images/icons/nav/screen-active.svg"
                            alt="My Campaigns"
                            title="My Campaigns"
                    /></a>
                </li>
                <li *ngIf="!isPreview">
                    <a
                        [routerLink]="['/campaign/new']"
                        routerLinkActive="selected"
                        class="text-center p-3 d-inline-block text-white"
                        ngbTooltip="New Campaign"
                        placement="right"
                    >
                        <img
                            src="./assets/images/icons/nav/new-campaign.svg"
                            alt="New Campaign"
                            title="New Campaign" />
                        <img
                            src="./assets/images/icons/nav/new-campaign-active.svg"
                            alt="New Campaign"
                            title="New Campaign"
                    /></a>
                </li>
                <li *ngIf="!isPreview">
                    <a
                        [routerLink]="['/my-account/my-wallet']"
                        routerLinkActive="selected"
                        class="text-center p-3 d-inline-block text-white"
                        ngbTooltip="My Account"
                        placement="right"
                    >
                        <img
                            src="./assets/images/icons/nav/wallet.svg"
                            alt="My Account"
                            title="My Account" />
                        <img
                            src="./assets/images/icons/nav/wallet-active.svg"
                            alt="My Account"
                            title="My Account"
                    /></a>
                </li>
                <li *ngIf="!isPreview">
                    <a
                        [routerLink]="['/campaign-analytics']"
                        routerLinkActive="selected"
                        class="text-center p-3 d-inline-block text-white"
                        ngbTooltip="Campaign Analytics"
                        placement="right"
                    >
                        <img
                            src="./assets/images/icons/nav/analytics.svg"
                            alt="Campaign Analytics"
                            title="Campaign Analytics" />
                        <img
                            src="./assets/images/icons/nav/analytics-active.svg"
                            alt="Campaign Analytics"
                            title="Campaign Analytics"
                    /></a>
                </li>
                <li>
                    <a
                        [routerLink]="['/contact-us']"
                        routerLinkActive="selected"
                        class="text-center p-3 d-inline-block text-white"
                        ngbTooltip="Contact us"
                        placement="right"
                    >
                        <img
                            src="./assets/images/contact.svg"
                            alt="Contact us"
                            title="Contact us" />
                        <img
                            src="./assets/images/contact-active.svg"
                            alt="Contact us"
                            title="Contact us"
                    /></a>
                </li>
            </ul>
        </nav>
    </div>
    <div class="user-section text-center">
        <span class="avatar d-flex align-items-center justify-content-center mb-3">
            <img src="./assets/images/man-avatar.svg" alt="My Dashboard" title="My Dashboard" />
        </span>
        <span class="text-white d-block montserrat-light">Welcome!</span>
        <a
            [routerLink]="['/my-account/']"
            href="javascript:;"
            class="text-white montserrat-bold d-inline-block mb-4"
            >{{ user?.firstName + ' ' + user?.lastName }}</a
        >
        <div>
            <a class="btn btn-link text-white" (click)="signOut()">Sign out</a>
        </div>
        <a (click)="hiddenNav = !hiddenNav" class="btn btn-sm button-nav-shown"
            ><mat-icon>arrow_back_ios</mat-icon></a
        >
    </div>
</div>
